module.exports = __webpack_public_path__ + "faq/img/evaluate_2.826d998e.png";